<template>
    <div>
        <h2>{{ $t('definitions') }}</h2>
        <h3>{{ $t('definitions_list.conditional_use') }}</h3>
        <p>{{ $t('definitions_list.def_conditional_use') }}</p>
        <h3>{{ $t('definitions_list.demo') }}</h3>
        <p>{{ $t('definitions_list.def_demo') }}</p>
        <h3>{{ $t('definitions_list.internal_approval') }}</h3>
        <p v-html="$t('definitions_list.def_internal_approval')"></p>
        <h3>{{ $t('definitions_list.variance') }}</h3>
        <p>{{ $t('definitions_list.def_variance') }}</p>
        <h3>{{ $t('definitions_list.appeal') }}</h3>
        <p>{{ $t('definitions_list.def_appeal') }}</p>
        <h3>{{ $t('definitions_list.subdivision_and_rezoning') }}</h3>
        <p>{{ $t('definitions_list.def_subdivision_and_rezoning') }}</p>
        <h3>{{ $t('definitions_list.subdivision') }}</h3>
        <p>{{ $t('definitions_list.def_subdivision') }}</p>
        <h3>{{ $t('definitions_list.rezoning') }}</h3>
        <p>{{ $t('definitions_list.def_rezoning') }}</p>
        <h3>{{ $t('definitions_list.zoning_agreement_amendment') }}</h3>
        <p>{{ $t('definitions_list.def_zoning_agreement_amendment') }}</p>
    </div>
</template>

<script>
	export default {

	}
</script>

<style>

</style>
